import { ReactNode } from 'react';
import { Typography } from '@optimus-web/core';
import { UnicodeEntity } from '@mews/enums';

interface Props {
    count: number;
    item: ReactNode;
}

const CountLabel = ({ count, item }: Props) => (
    <Typography textStyle="bodyMediumStrong" variant="secondary" as="div">
        {count}
        {UnicodeEntity.MultiplicationSign}
        {UnicodeEntity.NoBreakSpace}
        {item}
    </Typography>
);

export default CountLabel;
